module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/338629/equipment04-5574d0ed9e4d710f929fee63a6de2dc4.png";